/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import './transaction';
import './estimated_transfer_event';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "sfs": {
        "nested": {
          "models": {
            "nested": {
              "TransactionDetails": {
                "fields": {
                  "transaction": {
                    "type": ".squareup.sfs.models.Transaction",
                    "id": 1,
                    "rule": "optional"
                  },
                  "toAccountName": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "fromAccountName": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "transferEvents": {
                    "type": ".squareup.sfs.models.EstimatedTransferEvent",
                    "id": 4,
                    "rule": "repeated"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.sfs?.nested?.models?.nested?.TransactionDetails) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc Transaction plus additional details not directly available from the ListTransactions API.
 * --
 *
 * SOURCE TransactionDetails @ squareup/sfs/models/transaction_details.proto at 13:1
 */
export const TransactionDetails = $root.lookupType('squareup.sfs.models.TransactionDetails');
fixType(TransactionDetails, {
  transaction: {
    required: true
  },
  toAccountName: {
    required: true
  },
  fromAccountName: {
    required: true
  }
});
Builder.createAndAttachToType(TransactionDetails);